<template>
    <slot
        :is-menu-shown="isMenuShown"
        :is-search-shown="isSearchShown"
        :has-cart-items="hasCartItems"
        :cart-item-count="cartItemCount"
        :has-wishlist-items="hasWishlistItems"
        :wishlist-item-count="wishlistItemCount"
        :on-click-outside="onClickOutside"
        :on-open-search="onOpenSearch"
        :on-toggle-menu="onToggleMenu"
        :set-search-ref="setSearchRef"
    ></slot>
</template>

<script>

export default {
    data() {
        return {
            isMenuShown: false,
            isSearchShown: false,
            searchRef: null,
        };
    },

    computed: {
        cartItemCount() {
            return this.$store.getters['cart/itemCount'];
        },
        hasCartItems() {
            return this.$store.getters['cart/hasItems'];
        },
        wishlistItemCount() {
            return this.$store.getters['wishlist/itemCount'];
        },
        hasWishlistItems() {
            return this.$store.getters['wishlist/hasItems'];
        },
    },

    methods: {
        setSearchRef(el) {
            this.searchRef = el;
        },

        onOpenSearch(event) {
            if (!this.isSearchShown) {
                event.preventDefault();

                this.isSearchShown = true;

                this.$nextTick(() => {
                    this.searchRef.focus();
                });
            }
        },
        onClickOutside() {
            this.isSearchShown = false;
        },
        onToggleMenu() {
            this.isMenuShown = !this.isMenuShown;
        },
    },
};
</script>
